module.exports = __webpack_public_path__ + "86932ac5653efbb6e49ed42308a88202.png";